import React, { useState } from 'react';
import { Alert, AlertTitle, Button, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import {
  dismissPasskeyPortabilityNudge,
  shouldShowPasskeyPortabilityNudge,
  clearMfaPortabilitySession,
} from '../../utils/mfaPortability';

/**
 * Soft nudge when the user signed in with TOTP/backup/email while passkeys are enrolled.
 * Password-manager passkeys are often browser-specific — keep authenticator app as the portable safety net.
 */
const PasskeyPortabilityBanner: React.FC = () => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(() => shouldShowPasskeyPortabilityNudge());

  if (!visible) return null;

  return (
    <Alert
      severity="warning"
      sx={{ mb: 2 }}
      onClose={() => {
        dismissPasskeyPortabilityNudge();
        setVisible(false);
      }}
      action={
        <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
          <Button
            color="inherit"
            size="small"
            variant="outlined"
            onClick={() => {
              clearMfaPortabilitySession();
              setVisible(false);
              navigate('/profile');
            }}
          >
            Account Settings
          </Button>
        </Stack>
      }
    >
      <AlertTitle>Passkey may not work in every browser</AlertTitle>
      You signed in with a code, not a passkey. Password-manager passkeys (Google/Microsoft) often work only in
      browsers tied to that account — Brave and Chrome are not always interchangeable. Keep an{' '}
      <strong>authenticator app</strong> enabled so you are not locked out on another browser or device. You can
      also add a passkey for this browser under Account Settings.
    </Alert>
  );
};

export default PasskeyPortabilityBanner;
